import configs from "./configs";
import { apiRequest, eventDetailToUiModel } from "./events-utils";

export function createEventService({ baseUrl, request }) {
  const eventPath = eventSlug => `${baseUrl}/events/${encodeURIComponent(eventSlug)}`;

  return {
    async fetchEvent(slug) {
      return eventDetailToUiModel(await request("GET", eventPath(slug)));
    },

    async registerForEvent({ eventSlug, sessionSlugs = [], ticketSellableId }) {
      const body = { session_slugs: sessionSlugs };
      if (ticketSellableId) body.ticket_sellable_id = ticketSellableId;
      return await request("POST", `${eventPath(eventSlug)}/registrations`, body);
    },

    async bookEventSession({ eventSlug, sessionSlug }) {
      return await request("POST", `${eventPath(eventSlug)}/sessions/${encodeURIComponent(sessionSlug)}/bookings`);
    },

    async getEventAdmission({ eventSlug }) {
      return await request("GET", `${eventPath(eventSlug)}/admission`);
    },

    async getSessionAdmission({ eventSlug, sessionSlug }) {
      return await request("GET", `${eventPath(eventSlug)}/sessions/${encodeURIComponent(sessionSlug)}/admission`);
    },

    async getSessionShare({ eventSlug, sessionSlug }) {
      return await request(
        "POST",
        `${eventPath(eventSlug)}/sessions/${encodeURIComponent(sessionSlug)}/share?include_room_link=true`
      );
    }
  };
}

const service = createEventService({ baseUrl: configs.CUSTOM_API_URL, request: apiRequest });

export const fetchEvent = service.fetchEvent;
export const registerForEvent = service.registerForEvent;
export const bookEventSession = service.bookEventSession;
export const getEventAdmission = service.getEventAdmission;
export const getSessionAdmission = service.getSessionAdmission;
export const getSessionShare = service.getSessionShare;
